module.exports = __webpack_public_path__ + "static/media/s_v8_t3.149c90ef.mp3";